export default __webpack_public_path__ + "static/media/Poppinsbold.8ac6f632.ttf";